module.exports = __webpack_public_path__ + "images/wappen-harmonie-muenchen-weiss-8dfccbf8c68f7820a0c25eb425668172.png";